import React, { lazy, Suspense, useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import PageNotFound from "./Pagenotfound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Preloader } from "../components/Preloader";

const Home = lazy(() => import("./Home/index"));
const Contact = lazy(() => import("./ContactUs/index"));
const Blog = lazy(() => import("./Blog/index"));
const Projects = lazy(() => import("./Projects/index"));
const Services = lazy(() => import("./Services/index"));
const About = lazy(() => import("./AboutUs/index"));
const Testimonials = lazy(() => import("./Testimonials/index"));
const Teams = lazy(() => import("./Team/index"));
const Faqs = lazy(() => import("./Faq/index"));

export const Layout = () => {
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
  }, [location]);

  const handleLoad = () => {
    setLoading(false);
  };
  return (
    <div>
      {loading && <Preloader />}
      <ToastContainer />
      <Header />
      <main>
        <Suspense fallback={<Preloader />}>
          <Routes>
            <Route path="/" element={<Home onLoad={handleLoad} />} />
            <Route path="/contact" element={<Contact onLoad={handleLoad} />} />
            <Route path="/blog" element={<Blog onLoad={handleLoad} />} />
            <Route
              path="/projects"
              element={<Projects onLoad={handleLoad} />}
            />
            <Route
              path="/services"
              element={<Services onLoad={handleLoad} />}
            />
            <Route path="/about-us" element={<About onLoad={handleLoad} />} />
            <Route
              path="/testimonials"
              element={<Testimonials onLoad={handleLoad} />}
            />
            <Route path="/teams" element={<Teams onLoad={handleLoad} />} />
            <Route path="/faqs" element={<Faqs onLoad={handleLoad} />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};
